import React, { Suspense, lazy } from "react"
import Loading from "./../Loading/index"

const LoadableComponent = (importFunc: any) => {
  const LazyComponent = lazy(importFunc)
  const Loadable = (props: any) => (
    <Suspense fallback={<Loading />}>
      <LazyComponent {...props} />
    </Suspense>
  )
  Loadable.displayName = "Loadable"
  return Loadable
}

export default LoadableComponent
